import type { LocaleDictionary } from "@/i18n/types";

const nsOrgJA = {
  list: {
    title: "あなたの参加組織",
    invitedTitle: "招待された組織",
  },
  tab: {
    joined: "参加中の組織",
    invited: "招待された組織",
  },
  table: {
    header: {
      name: "組織名",
      shortName: "組織略称",
      kind: "組織種別",
      memberCount: "所属人数",
      description: "概要",
      mfa: "2段階認証",
      action: "アクション",
      isOwner: "オーナー権限有無",
    },
    mfa: {
      required: "必須",
      optional: "任意",
      notConfiguredAlert: "2段階認証が未設定です",
    },
    defaultOrgChangeError: "基本組織設定に失敗しました",
  },
  invitation: {
    acceptButton: "承諾",
    rejectButton: "拒否",
    accept: {
      errorMessage: "招待の承諾に失敗しました",
    },
    reject: {
      confirmTitle: "組織の招待拒否",
      confirmMessage: "組織の招待を拒否しますか？",
      confirmMessageWithName: ({
        organizationName,
      }: {
        organizationName: string;
      }) => `${organizationName} の招待を拒否しますか？`,
      confirmButton: "招待拒否",
      inProgressTitle: "招待を拒否中",
      successMessage: "招待を拒否しました",
      errorMessage: "招待の拒否に失敗しました",
    },
    mfaRequired: {
      title: "2段階認証の設定が必要です",
      description:
        "この組織では、セキュリティのため2段階認証が必須です。\nアカウント設定から2段階認証を有効にしてから、再度承諾してください。",
      stepsTitle: "設定手順",
      step1: "アカウント設定画面を開く",
      step2: "2段階認証を「有効」にし、「変更」を押す",
      step3: "再ログイン後、この画面に戻って再度「承諾」を押す",
      guideLink: "設定方法を見る",
      accountSettingButton: "アカウント設定へ",
      closeButton: "閉じる",
    },
  },
  menu: {
    ariaLabel: "組織メニュー",
    switchButton: "組織を切り替え",
    pendingInvitations: ({ count }: { count: number }) =>
      `招待承認待ち組織が${count}件あります`,
    organizationGroup: "組織",
    addonGroup: "アドオン",
    setting: "組織設定",
    settingItem: {
      organizationInfo: "組織情報",
      functions: "機能",
      members: "メンバー",
      categories: "カテゴリー",
      roles: "ロール（権限）",
      notifications: "通知",
      cliApiKeys: "CLI APIキー",
    },
  },
  switchDialog: {
    title: "組織を切り替える",
    description: "現在ログインしている組織から別の組織に切り替えます。",
    noOrganizations: "所属している組織はありません",
    underMaintenance: "メンテナンス中の組織です",
    cancelButton: "キャンセル",
  },
  infoDialog: {
    title: "組織情報",
    name: "組織名",
    id: "組織ID",
    description: "概要",
    memberCount: "組織人数",
    closeButton: "閉じる",
  },
} satisfies LocaleDictionary;

export default nsOrgJA;
